import React, { Component } from 'react'
import './LineChart.css'
class LineChart extends Component {
  getMinX() {
    const { data } = this.props
    const only_x = data.map(obj => obj.x)
    const min_x = Math.min.apply(null, only_x)
    return min_x
  }
  getMinY() {
    const { data } = this.props
    const only_y = data.map(obj => obj.y)
    const min_y = Math.min.apply(null, only_y)
    return min_y
  }
  getMinY2() {
    const { data } = this.props
    const only_y = data.map(obj => obj.y2)
    const min_y2 = Math.min.apply(null, only_y)
    return min_y2
  }
  getMaxX() {
    const { data } = this.props
    const only_x = data.map(obj => obj.x)
    const max_x = Math.max.apply(null, only_x)
    return max_x
  }
  getMaxY() {
    const { data } = this.props
    const only_y = data.map(obj => obj.y)
    const max_y = Math.max.apply(null, only_y)
    return max_y
  }

  getMaxY2() {
    const { data } = this.props
    const only_y = data.map(obj => obj.y2)
    const max_y2 = Math.max.apply(null, only_y)
    return max_y2
  }
  getSvgX(x) {
    const { svgWidth } = this.props
    return ((x / this.getMaxX()) * svgWidth)
  }
  getSvgY(y) {
    const { svgHeight } = this.props
    return svgHeight - (y / this.getMaxY()) * svgHeight
  }

  makePath() {
    const { data, color } = this.props
    let pathD = ` M  ${this.getSvgX(data[0].x)} ${this.getSvgY(data[0].y)} `

    pathD += data.map((point, i) => {
      return `L ${this.getSvgX(point.x)} ${this.getSvgY(point.y)}  `
    })

    return (
      <path className="linechart_path" d={pathD} style={{ stroke: color }} />
    )
  }

  makePath2() {
    const { data, color2 } = this.props
    let pathD = ` M  ${this.getSvgX(data[0].x)} ${this.getSvgY(data[0].y)} `

    pathD += data.map((point, i) => {
      return `L ${this.getSvgX(point.x)} ${this.getSvgY(point.y2)}  `
    })

    return (
      <path className="linechart_path" d={pathD} style={{ stroke: color2 }} />
    )
  }

  text1() {
    const { data } = this.props
    console.log('text1 data')
    var x = []
    var y = []
    for(let i=0; i<data.length; i+=5) {
      var item = data[i]
      x.push(<text key={`txt_${i}`} x={this.getSvgX(`${item.x}`)} y={this.getSvgY(`${item.y2}`)} fill="black" >&nbsp;&pound;{item.y2}</text> )      
    }
    for(let i=0; i<data.length; i+=5) {
      var item = data[i]
      y.push(<text key={`txt_${i}`} x={this.getSvgX(`${item.x}`)} y={this.getSvgY(`${item.y}`)} fill="black" >&nbsp;&pound;{item.y}</text> )      
    }
    y.push(<text key={`txt_${6}`} x={this.getSvgX(`${data[24].x}`)} y={this.getSvgY(`${data[24].y}`)} fill="black" >&nbsp;&pound;{data[24].y}</text> )      
    console.log(x)
    return (
      <g key='text1' className="withsolar_points" fontFamily="Verdana" fontSize="10" >
      {x}
      {y}
      </g>
      )
  }

  text2 () {
    const { data } = this.props
    const minY1 = this.getMinY()
    const minY2 = this.getMinY2()
    const minY = data[1].y2 - data[0].y2
    console.log(`minY = ${minY}`)
    return (
      <g key='text12' className="withsolar_points2" fontFamily="Verdana" fontSize="10" >
      {data.map((item) => {
        return (
          <text key={`txt2_${item.x}`} x={this.getSvgX(`${item.x}`)} y={this.getSvgY(minY)} fill="black" >
            {item.x+1}
          </text>
        )
      })
      }
      </g>
    )
  }

  makeAxis() {
    const { data} = this.props
    const minX = this.getMinX()
    const maxX = this.getMaxX()
    const minY1 = this.getMinY()
    const minY2 = this.getMinY2()
    const maxY1 = this.getMaxY()
    const maxY2 = this.getMaxY2()
    const minY = Math.min(minY1,minY2)
    const maxY = Math.max(maxY1,maxY2)
    let step = parseInt((this.getSvgX(maxX)-this.getSvgX(minX)) / data.length??0)
    let step2 = parseInt(((this.getSvgY(minY)-this.getSvgY(maxY)) / data.length??0)*3)
    if(step <=0) step = 1
    const xpoints = []
    const ypoints = []
    console.log(`${this.getSvgX(minX)} ${this.getSvgX(maxX)} ${step} ${step2}`)
    for(let il=this.getSvgX(minX); il <this.getSvgX(maxX); il+=step ) { xpoints.push(il) }
    for(let il=this.getSvgY(maxY), j=data.length-1; il <this.getSvgY(minY); il+=step2, j-=3 ) { 
      ypoints.push({y:il, value: data[j].y })
    }
    console.log(xpoints)
    console.log(ypoints)
    console.log(`${step} ${step2}`)
    return (
      <g key='main-axis' className="linechart_axis">
        <line key='xazis'
          x1={this.getSvgX(minX)}
          y1={this.getSvgY(minY)}
          x2={this.getSvgX(maxX)}
          y2={this.getSvgY(minY)}
        />
        <line key='yaxis'
          x1={this.getSvgX(minX)}
          y1={this.getSvgY(minY)}
          x2={this.getSvgX(minX)}
          y2={this.getSvgY(maxY)}
        />
        {xpoints.map((item,index) => {
          return (
            <line key={`xaxis_${index}`}
            x1={item}
            y1={this.getSvgY(minY)}
            x2={item}
            y2={this.getSvgY(minY-100)}
          />
          )
        })
        }
        {ypoints.map((item, index) => {
          return (
            <line key={`yaxis_${index}`}
            x1={this.getSvgX(minX)}
            y1={item.y}
            x2={this.getSvgX(minX)+10}
            y2={item.y}
            />
          )
        })
        }
      </g>
    )
  }

  render() {
    console.log(this.props)
    const { svgHeight, svgWidth } = this.props

    return (
      <svg viewBox={`0 0 ${svgWidth+500} ${svgHeight}`}>
        {this.makePath()}
        {this.makePath2()}
        {this.text1()}
        {this.text2()}
        {this.makeAxis()}
      </svg>
    )
  }
}
LineChart.defaultProps = {
  data: [],
  color: '#ff4500',
  color2: '#00ff00',
  svgHeight: 266,
  svgWidth: 800,
}
export default LineChart
